import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

import { copyCampaignRequest } from '../actions';
import { useCampaignQueryContext } from '../campaignFolders/contexts/CampaignQueryContext';
import { useSelectionContext } from '../campaignFolders/contexts/SelectionContext';
import { useCampaignFolderModals } from '../hooks/useCampaignFolderModals';

const content = {
  modalHeader: 'Copy campaign?',
  confirmAction: 'Copy campaign',
  modalBodyText: (campaignName: string) =>
    `Create a copy of ${campaignName}? This will not schedule the new copied campaign.`,
};

export const CopyCampaignModal = () => {
  const { folderId, refetch } = useCampaignQueryContext();
  const { active, clearAll } = useSelectionContext();
  const modals = useCampaignFolderModals();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      // when an item gets set through the actions, we need to clear it on the way out
      clearAll();
    };
  }, []);

  const campaignSelection = active[0];

  const handleClose = () => {
    modals.copy.toggle(false);
  };

  const handleConfirmCopy = () => {
    dispatch(copyCampaignRequest(campaignSelection.id, folderId, refetch));
    handleClose();
  };

  return (
    <Modal
      data-test="copy-campaign-modal"
      id="copy-campaign-modal"
      isModalOpen={true}
      onClose={handleClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{content.modalHeader}</ModalHeader>
      <ModalBody>{content.modalBodyText(campaignSelection.name)}</ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test="confirm-copy-campaign-button"
          onClick={handleConfirmCopy}
          size={BUTTON_SIZES.LARGE}
        >
          {content.confirmAction}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
